import { render, staticRenderFns } from "./ProductCreation.vue?vue&type=template&id=329d5227&scoped=true"
import script from "./ProductCreation.vue?vue&type=script&lang=js"
export * from "./ProductCreation.vue?vue&type=script&lang=js"
import style0 from "./ProductCreation.vue?vue&type=style&index=0&id=329d5227&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329d5227",
  null
  
)

export default component.exports